export default "/images/d69ee704f03d67e488df1a5de88e1f7b.avif";